import React from 'react';
import { useSelector } from 'react-redux';

import { useIntl } from 'ha/i18n';
import { useParams } from 'ha/helpers/router';
import { Link } from '@ha/dsl';

import { getLocation } from '../selectors';

export const SearchAdvertiserLink: React.FC = () => {
  const { T, urlResolver } = useIntl();
  const { location } = useParams();

  const place = useSelector(getLocation);

  return (
    <Link
      to={urlResolver.absolutizePath(`/s/${location}`)}
      kind="mint-underline"
    >
      {T('See all listings in %s', place)}
    </Link>
  );
};

export default SearchAdvertiserLink;
